import React from 'react';
import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import times from 'lodash/times';
import FormHelperText from '@mui/material/FormHelperText';
import Form from 'components/form';
import { useForm } from './Form';
const { FormItem } = Form;

const SurveyField = React.forwardRef(
  ({ id, required, value, helpText, hasError, onChange }, ref) => {
    const theme = useTheme();
    const color = theme.palette.primary.main;
    return (
      <Box mt={2} maxWidth={400} mx="auto">
        <Grid container spacing={3} columns={10}>
          {times(10).map((i) => (
            <Grid item xs={2} key={i}>
              <Box
                onClick={() => onChange(i + 1)}
                sx={{
                  cursor: 'pointer',
                  backgroundColor: value === i + 1 ? color : '#fff',
                  border: `1px solid ${color}`,
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  color: value !== i + 1 ? color : '#fff',
                  fontSize: 20,
                  fontWeight: 600,
                }}
              >
                {i + 1}
              </Box>
            </Grid>
          ))}
        </Grid>
        {hasError && (
          <FormHelperText error sx={{ m: 0, mt: 1 }}>
            {helpText}
          </FormHelperText>
        )}
      </Box>
    );
  },
);

const Survey = ({ id, required }) => {
  const { getFieldDecorator } = useForm();
  return (
    <FormItem>
      {getFieldDecorator(id, {
        rules: [{ required, message: 'Please select a rating' }],
      })(<SurveyField />)}
    </FormItem>
  );
};

export default Survey;
